"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a SESSION_PROPERTIES_EVENT_2 request.
 */
var SessionPropertiesEventBatch = /** @class */ (function () {
    /**
     * Create a new SessionPropertiesEventBatch instance
     *
     * @param cid  the conversation ID
     * @param events  the session property events
     */
    function SessionPropertiesEventBatch(cid, events) {
        this.cid = cid;
        this.events = events;
    }
    return SessionPropertiesEventBatch;
}());
exports.SessionPropertiesEventBatch = SessionPropertiesEventBatch;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/session-properties-event-batch.js
// module id = 1294
// module chunks = 1